import React from "react";
import { motion } from "framer-motion";
import { FaReact } from "react-icons/fa";
import { TbBrandNextjs } from "react-icons/tb";
import { SiTailwindcss, SiFirebase, SiMongodb, SiTypescript } from "react-icons/si";
import { AiOutlineRobot } from "react-icons/ai";

const container = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1],
      when: "beforeChildren",
      staggerChildren: 0.1,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 30, scale: 0.98 },
  show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.55 } },
};

const tools = [
  { name: "React", icon: <FaReact className="text-3xl text-sky-400" />, pct: 98 },
  { name: "Next.js", icon: <TbBrandNextjs className="text-3xl text-gray-800" />, pct: 95 },
  { name: "Tailwind", icon: <SiTailwindcss className="text-3xl text-cyan-500" />, pct: 95 },
  { name: "Firebase", icon: <SiFirebase className="text-3xl text-amber-500" />, pct: 92 },
  { name: "MongoDB", icon: <SiMongodb className="text-3xl text-emerald-600" />, pct: 90 },
  { name: "TypeScript", icon: <SiTypescript className="text-3xl text-blue-600" />, pct: 88 },
  { name: "AI Agents", icon: <AiOutlineRobot className="text-3xl text-indigo-600" />, pct: 90 },
];

function Tools() {
  return (
    <section id="tools" className="py-14 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.3 }}
          className="flex items-center justify-center mb-8 sm:mb-10"
        >
          <motion.div variants={item} className="space-y-2 text-center">
            <p className="text-sm font-medium text-gray-500 flex items-center gap-2 justify-center">
              <span className="inline-block h-1.5 w-1.5 rounded-full" style={{ backgroundColor: "rgb(232, 51, 16)" }} />
              My Development Stack
            </p>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-extrabold tracking-tight leading-tight">
              <span style={{ color: "rgb(232, 51, 16)" }}>Technologies</span> I Build With
            </h2>
          </motion.div>
        </motion.div>

        {/* Tools pills */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.2 }}
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-4"
        >
          {tools.map((t, i) => (
            <motion.div
              key={i}
              variants={item}
              whileHover={{ y: -4 }}
              className="flex flex-col items-center justify-center rounded-[28px] bg-gray-50 border border-gray-200 shadow-sm py-6"
            >
              <div className="mb-2 flex items-center justify-center w-14 h-14 rounded-full bg-white shadow ring-1 ring-gray-100">
                {t.icon}
              </div>
              <div className="text-lg font-bold text-gray-900">{t.pct}%</div>
              <div className="text-sm text-gray-600 mt-1">{t.name}</div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default Tools;
